import * as d3 from 'd3'
export default {

  methods: {
    /*
      app_Line(d, idx)
      app_Rect(d, idx)
    */

    app_Lines(selection, idx, data, obj) {
      
      let lineGroup = selection
      .append('g')
      .attr('transform', `translate(${obj.x + .5}, ${obj.y + .5})`)

      obj.cols.forEach((d,i)=> {

        if(d.repeat) {
          let st = obj.repeat.find(f=> f.id == d.repeat)
          if(!st) return

          let repeat = lineGroup
          .append('g')
          .attr('transform', `translate(${d.x}, ${d.y})`)

          for(let r=1; r<=st.no; r++) {
            repeat
            .append('line')
            .attr('x1', d.x1).attr('y1', d.y1 + .5)
            .attr('x2', d.x2).attr('y2', d.y2 + .5)
            .attr('stroke', d.stroke ? d.stroke : obj.stroke)
            .attr('stroke-width', d.sWidth ? d.sWidth : obj.sWidth)
            .attr('opacity', d.opacity ? d.opacity : obj.opacity)

            d.x1 += st.stepX; d.x2 += st.stepX
            d.y1 += st.stepY; d.y2 += st.stepY
          }
        } else {
          lineGroup
          .append('line')
          .attr('x1', d.x1).attr('y1', d.y1 + .5)
          .attr('x2', d.x2).attr('y2', d.y2 + .5)
          .attr('stroke', d.stroke ? d.stroke : obj.stroke)
          .attr('stroke-width', d.sWidth ? d.sWidth : obj.sWidth)
          .attr('opacity', d.opacity ? d.opacity : obj.opacity)
        }
      })
    },



    app_Rectangles(selection, idx, data, obj) {

      let items = selection
      .append('g')
      .attr('transform', `translate(${.5}, ${.5})`)

      obj.cols.forEach((d,i)=> {
        items
        .append('rect')
        .attr('x', d.x) .attr('y', d.y)
        .attr('width', d.width)
        .attr('height', d.height)
        .attr('rx', d.radius ? d.radius : obj.radius)
        .attr('ry', d.radius ? d.radius : obj.radius)
        .attr('fill', ()=> {
          let color = d.fill ? d.fill : obj.fill
          color = color.charAt(0) == '#' ? color : `url(#${this.localId}_${color})`
          return color
        })
        .attr('stroke', d.stroke ? d.stroke : obj.stroke)
        .attr('stroke-width', d.sWidth ? d.sWidth : obj.sWidth)
        .attr('opacity', d.opacity ? d.opacity : obj.opacity)
      })
    },


    
  }
}
